import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { TFlex } from 'foundations-components/transitional/components/TFlex';

// @ts-expect-error no types
import EmailAssetDialog from '../../../shareAsset/dialog/EmailAssetDialog';
import { DEFAULT_SHARING_METHODS } from '../../../../constants/sharingMethods';
// @ts-expect-error no types
import ShareToSlackAssetDialog from '../../../shareAsset/dialog/ShareToSlackAssetDialog';
import { useShareViaSettings } from '../ShareViaSettingsContext';
import integrations from '../../../../utils/integrations';
// @ts-expect-error no types
import { useControlsContext } from '../../../shareAsset/context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COMMON_I18N_KEYS = {
  title: 'reporting-action-components.actions.shareVia.dialog.steps.configurationStep.title',
  description: 'reporting-action-components.actions.shareVia.dialog.steps.configurationStep.description'
};
const GOOGLE_CHAT_I18N_KEYS = Object.assign({}, COMMON_I18N_KEYS, {
  description: 'reporting-action-components.actions.shareVia.dialog.steps.configurationStep.googleChatDescription'
});
const getI18nKeys = appId => integrations.isGoogleChatAppId(appId) ? GOOGLE_CHAT_I18N_KEYS : COMMON_I18N_KEYS;
const ConfigurationStepContent = () => {
  const {
    selectedAppData
  } = useShareViaSettings();
  const {
    currentDialog
  } = useControlsContext();
  const getConfigurationComponent = () => {
    switch (currentDialog) {
      case DEFAULT_SHARING_METHODS.EMAIL:
        return /*#__PURE__*/_jsx(EmailAssetDialog, {});
      default:
        return /*#__PURE__*/_jsx(ShareToSlackAssetDialog, {});
    }
  };
  const i18nKeys = getI18nKeys(selectedAppData === null || selectedAppData === void 0 ? void 0 : selectedAppData.id);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H4, {
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKeys.title,
        options: {
          appName: selectedAppData === null || selectedAppData === void 0 ? void 0 : selectedAppData.name
        }
      })
    }), /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKeys.description,
        options: {
          appName: selectedAppData === null || selectedAppData === void 0 ? void 0 : selectedAppData.name
        }
      })
    }), /*#__PURE__*/_jsx(TFlex, {
      marginBlockStart: "400",
      paddingBlockEnd: "900",
      children: getConfigurationComponent()
    })]
  });
};
export default ConfigurationStepContent;